import React from "react";
import { Facebook, Linkedin, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-blue-950 text-gray-200 py-10" id="contact">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row justify-between items-start gap-10 md:gap-20">
        
        {/* Left: Logo */}
        <div className="flex-1">
          <img src="/footer-logo.png" alt="Sairaj Infotech" className="h-52 w-56 object-contain" />
          <p className="text-sm text-white -mt-6">
            Empowering businesses with secure and smart IT solutions.
          </p>
        </div>

       {/* Center: Contact Us */}
      <div className="flex-1 space-y-3 md:text-center text-left mt-10">
       <h4 className="text-lg font-semibold text-white">Contact Us</h4>

       <div className="flex flex-col items-start md:items-center gap-2 text-sm text-gray-300">
         <div className="flex items-center gap-2">
           <Mail size={18} /> <span>admin@sairajinfo.com</span>
         </div>

         <div className="flex items-center gap-2">
          <Phone size={18} /> <span>+91-9730657779</span>
         </div>

         <div className="flex items-center md:gap-3">
           <MapPin size={18} /> 
           <span>
            Office no 1,First Floor,Shree Dattatray Apartment,<br/> 
            Pawan Nagar Lane No 2 Dapodi Road,<br/> 
            Pimple Gurav, Pune 411061.
            </span>
         </div>
        </div>
      </div>


        {/* Right: Social Media */}
        <div className="flex-1 space-y-3 md:text-right mt-10 ">
          <h4 className="text-lg font-semibold text-white">Follow Us</h4>
          <div className="flex md:justify-end gap-4">
            <a
              href="https://www.linkedin.com/in/vishal-patil-03032932a/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-blue-500 transition-colors"
            >
              <Linkedin size={24} />
            </a>
            <a
              href="https://www.facebook.com/share/1AVEPGX19Y/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-blue-500 transition-colors"
            >
              <Facebook size={24} />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="text-center text-white text-sm mt-10">
        © {new Date().getFullYear()} Sairaj Infotech. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
